import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { onMounted, computed } from 'vue'
import { useDisplay } from 'vuetify'
import { themedSettings } from '@/plugins/vuetify'
import { useAuthStore } from '@/stores/authStore'
import { useCaseStore } from './stores/caseStore'
import { useEstatesStore } from './stores/estateStore'
import { useServicesStore } from './stores/serviceStore'
import appHeader from '@/components/layout/app-header.vue'
import appFooter from '@/components/layout/app-footer.vue'
import infoBar from '@/components/ui/info-bar.vue'
import breadcrumbBar from '@/components/ui/breadcrumb-bar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

console.log('initiating app as: ' + process.env.VUE_APP_PUBLISHED_SITE)
console.log('app envieronment: ' + process.env.NODE_ENV)

const AuthStore = useAuthStore()
const CaseStore = useCaseStore()
const EstateStore = useEstatesStore()
const ServiceStore = useServicesStore()
const display = useDisplay()

const getContentPaddingClass = computed(() => {
  if (display.width.value <= themedSettings.isMobileViewWidth) {
    return 'xpadding-mobile'
  } else if (display.width.value < themedSettings.maxWidth) {
    return 'xpadding-other'
  } else {
    return 'xpadding-responsive'
  }
})

const columnSizes = computed(() => {
  const { xs, sm, md } = useDisplay()
  return xs.value || sm.value || md.value ? [12, 12] : [8, 4]
})

const getTextClasses = computed(() => {
  if (display.width.value <= themedSettings.isMobileViewWidth) {
    return {
      h1: 'text-c-h2',
      h2: 'text-c-h3'
    }
  } else {
    return {
      h1: 'text-c-h1',
      h2: 'text-c-h2'
    }
  }
})

function checkForDemoMode () {
  if (process.env.VUE_APP_PUBLISHED_SITE === 'demo') {
    AuthStore.setDemoData()
    CaseStore.setDemoData()
    EstateStore.setDemoData()
    ServiceStore.setDemoData()
  }
}

onMounted(() => {
  document.documentElement.style.setProperty(
    '--max-width',
    themedSettings.maxWidth - 160 - 18 + 'px'
  )
  checkForDemoMode()
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(appHeader, {
        class: _normalizeClass(getContentPaddingClass.value)
      }, null, 8, ["class"]),
      _createVNode(appFooter),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          (_unref(AuthStore).isAuthenticated &&
      _unref(AuthStore).chosenRepresentative &&
      getContentPaddingClass.value !== 'xpadding-mobile'
      )
            ? (_openBlock(), _createBlock(infoBar, {
                key: 0,
                class: _normalizeClass(getContentPaddingClass.value)
              }, null, 8, ["class"]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_view, {
            class: _normalizeClass(getContentPaddingClass.value),
            textClass: getTextClasses.value,
            columnSizes: columnSizes.value,
            paddingClass: getContentPaddingClass.value
          }, null, 8, ["class", "textClass", "columnSizes", "paddingClass"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})